/* Imports */
import axios from "../api/api";
/* /Imports/ */

/* 
  Class: ChartService
  Description: This class is responsible for charts stuff.
*/
class ChartService {
  /* 
    Obtain all charts from the api.
  */
  getCharts() {
    return axios.get("api/charts").then((response) => {
      return response.data.charts;
    });
  }

  /* 
    Obtain single chart from the api.
  */
  getChart(id) {
    return axios.get("api/charts/" + id).then((response) => {
      return response.data.chart;
    });
  }

  /* 
    Obtain additional data for single chart from the api.
  */
  getChartData(id) {
    return axios.get("api/charts/" + id + "/data").then((response) => {
      return response.data;
    });
  }
}

export default new ChartService();